import { EXPRESS_API } from 'configs/api/expressApi';
import { useQuery } from 'react-query';
import { crmKeys } from './crmKeys';
import { VinSolutionsDealer } from './types';

const getDealerForCustomer = async () => {
  const res = await EXPRESS_API.get(`/crm/vinsolutions/dealer`);
  return res.data as VinSolutionsDealer;
};

type DealerCustomerParams = {
  enabled?: boolean;
};

export const useGetVinSolutionsDealerForCustomer = ({
  enabled = false,
}: DealerCustomerParams) => {
  return useQuery(crmKeys.dealer_for_customer(), getDealerForCustomer, {
    enabled,
  });
};
